import { Dispatch } from "redux";
import { IAdHocProjectGroupResult, IAdHocProjectResult, IExportGroupProject, IGroupProject, IProject } from "../../models/applicationState";
import AdHocOcrV2Service from "../../services/adHocOcrV2Service";
import { createPayloadAction, IPayloadAction } from "./actionCreators";
import { ActionTypes } from "./actionTypes";


export default interface IAdHocOcrV2Actions {
    loadAdHocOcrProject(requestId: string): Promise<IProject>;
    exportProjectLabelToSource(projectId: string, runGenerateModel: boolean);

    loadAdHocOcrGroupProject(groupId: string): Promise<IGroupProject>;
    loadAdHocOcrProjectFromGroup(project: IAdHocProjectResult);
    exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject);
    setGenerateModelGroup(modelProjects: Array<{ key: string; val: string }>);
}

export function loadAdHocOcrProject(requestId: string): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV2Service();
            const project = await service.load(requestId);
            if (project) {
                dispatch(loadAdHocOcrV2ProjectAction(project));
            }
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

export interface ILoadAdHocOcrV2ProjectAction extends IPayloadAction<string, IAdHocProjectResult> {
    type: ActionTypes.AD_HOC_OCR_V2_LOAD_PROJECT
}

export const loadAdHocOcrV2ProjectAction = createPayloadAction<ILoadAdHocOcrV2ProjectAction>(ActionTypes.AD_HOC_OCR_V2_LOAD_PROJECT);

export function exportProjectLabelToSource(projectId: string, runGenerateModel: boolean) {
    return async (dispatch: Dispatch) => {
        try {
            const adHocOcrService = new AdHocOcrV2Service();
            const result = await adHocOcrService.exportProjectLabelToSource(projectId, runGenerateModel);
            return Promise.resolve(result);
        }
        catch(e) {
            return Promise.reject(e);
        }
    }    
}

export function exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject) {
    return async (dispatch: Dispatch) => {
        try {
            const adHocOcrService = new AdHocOcrV2Service();
            const result = await adHocOcrService.exportGroupProjectLabelToSource(exportGroupProject);
            return Promise.resolve(result);
        }
        catch(e) {
            return Promise.reject(e);
        }
        
    }    
}

export function loadAdHocOcrProjectFromGroup(project: IAdHocProjectResult) {
    return async (dispatch: Dispatch) => {
        dispatch(loadAdHocOcrV2ProjectAction(project));
    }
}

export function loadAdHocOcrGroupProject(groupId: string): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV2Service();
            const group = await service.loadGroup(groupId);
            if (group) {
                dispatch(loadAdHocOcrV2ProjectAction(group.adHocProjectModels[0]));
                dispatch(loadAdHocOcrGroupProjectAction(group));
            }
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

export interface ILoadAdHocOcrGroupProjectAction extends IPayloadAction<string, IAdHocProjectGroupResult> {
    type: ActionTypes.AD_HOC_OCR_GROUP_LOAD_PROJECT
}

export const loadAdHocOcrGroupProjectAction = createPayloadAction<ILoadAdHocOcrGroupProjectAction>(ActionTypes.AD_HOC_OCR_GROUP_LOAD_PROJECT);

export function setGenerateModelGroup(modelProjects: Array<{ key: string; val: string }>): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(setGenerateGroupAction(modelProjects));
    }
}

export interface ISetGenerateModelGroupAction extends IPayloadAction<string, Array<{ key: string; val: string }>> {
    type: ActionTypes.SET_GENERATE_MODEL_GROUP
}
export const setGenerateGroupAction = createPayloadAction<ISetGenerateModelGroupAction>(ActionTypes.SET_GENERATE_MODEL_GROUP);